import { memo, useEffect, useRef } from 'react'
import { useLocation } from 'react-router'
import { Id, toast, ToastContainer } from 'react-toastify'
import { removeToast } from '../../store/toasts/actions'
import { getToasts } from '../../store/toasts/selectors'
import { useAppDispatch, useAppSelector } from '../../store/types'

import styles from './Toasts.module.scss'

const PERSISTENT_TOAST_IDS: ReadonlySet<Id> = new Set(['ws-force-reload'])

const Toasts = () => {
  const toasts = useAppSelector(getToasts)
  const dispatch = useAppDispatch()
  const location = useLocation()
  const visibleToastIdsRef = useRef<Set<Id>>(new Set())

  useEffect(() => {
    if (toasts) {
      toasts.forEach((item) => {
        const { message, options, additionalFunc } = item
        const toastId = options.toastId!
        const userOnClose = options.onClose
        options.onOpen = () => {
          visibleToastIdsRef.current.add(toastId)
          dispatch(removeToast(toastId))
          additionalFunc && dispatch(additionalFunc)
        }
        options.onClose = (...args) => {
          visibleToastIdsRef.current.delete(toastId)
          userOnClose?.(...args)
        }

        toast[options.type](message, options)
      })
    }
  }, [toasts, dispatch])

  useEffect(() => {
    for (const toastId of visibleToastIdsRef.current) {
      if (!PERSISTENT_TOAST_IDS.has(toastId)) {
        toast.dismiss(toastId)
      }
    }
  }, [location])

  return (
    <ToastContainer
      toastClassName={styles.toasts}
      position="top-center"
      theme="colored"
      // limit={8} // causes toasts after the limit to repeat
    />
  )
}

export default memo(Toasts)
